import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgGoogleFill = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M2.25 12C2.25 6.61779 6.61779 2.25 12 2.25C14.4464 2.25 16.6811 3.14744 18.3891 4.64085C18.5444 4.77661 18.6369 4.97031 18.6449 5.1764C18.6529 5.38249 18.5757 5.58278 18.4314 5.73015L15.9559 8.25868C15.6855 8.53489 15.2495 8.56034 14.9487 8.31746C14.1418 7.66566 13.1189 7.278 12 7.278C9.39021 7.278 7.278 9.39021 7.278 12C7.278 14.6098 9.39021 16.722 12 16.722C13.7104 16.722 15.2043 15.8186 16.0342 14.46H12C11.5858 14.46 11.25 14.1242 11.25 13.71V10.38C11.25 9.96579 11.5858 9.63 12 9.63H20.8475C21.208 9.63 21.5176 9.88658 21.5845 10.2409C21.6913 10.8067 21.75 11.3933 21.75 12C21.75 12.6297 21.6919 13.2549 21.5741 13.8537C20.7053 18.348 16.7488 21.75 12 21.75C6.61779 21.75 2.25 17.3822 2.25 12Z",
		fill: "currentColor"
	})
});
export default SvgGoogleFill;
